import { Base } from "../../framework/base";
import { UserType } from "../enums";
var ModifyUser = /** @class */ (function () {
    function ModifyUser(obj) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.date = obj && obj.date || 0;
        this.picture = obj && obj.picture || "";
        this.userType = obj && obj.userType || UserType.Normal;
    }
    ModifyUser.prototype.isRemoved = function () {
        return this.userType === UserType.Removed;
    };
    ModifyUser.createModifyUser = function (code, name, date, picture) {
        var result = new ModifyUser();
        result.code = code;
        result.name = name;
        result.date = date;
        result.picture = picture;
        result.userType = UserType.Normal;
        return result;
    };
    ModifyUser.sortModifyUsers = function (items, _a) {
        var _b = _a === void 0 ? { column: "name", asc: true, currentUserCode: null } : _a, _c = _b.column, column = _c === void 0 ? "name" : _c, _d = _b.asc, asc = _d === void 0 ? true : _d, _e = _b.currentUserCode, currentUserCode = _e === void 0 ? null : _e;
        if (!items && items.length < 2)
            return items;
        var result;
        if (column === "code") {
            result = items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
        else if (column === "date") {
            result = items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.date, b.date)); });
        }
        else {
            result = items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        }
        if (currentUserCode) {
            result = Base.moveToFirst(result, result.findIndex(function (i) { return i.code === currentUserCode; }));
        }
        return result;
    };
    return ModifyUser;
}());
export { ModifyUser };
